import i18next from 'i18next';

i18next.addResources('es', 'contentSelector', {
  allContents: 'Contenidos',
  contents: 'Contenidos',
  articles: 'Artículos',
  infographic: 'Infografías',
  notes: 'Notas',
  news: 'Noticias',
  publications: 'Publicaciones',
  videos: 'Videos'
});

i18next.addResources('en', 'contentSelector', {
  allContents: 'All Content',
  contents: 'Content',
  articles: 'Articles',
  infographic: 'Infographics',
  notes: 'Notes',
  news: 'News',
  publications: 'Publications',
  videos: 'Videos'
});

i18next.addResources('pt', 'contentSelector', {
  allContents: 'Todos os Conteúdos',
  contents: 'Conteúdo',
  articles: 'Artigos',
  infographic: 'Infográficos',
  notes: 'Notas',
  news: 'Notícias',
  publications: 'Publicações',
  videos: 'Vídeos'
});
